module.exports = __webpack_public_path__ + "img/蒙版组 19@2x.dac23a5a.webp";